// Core Components
import MDCButton from "./MDCButton";
import { makeStyles } from "@mui/styles";

// Assets
import supportHeadsetIcon from "../../assets/images/icon_support_headset.svg";

const useStyles = makeStyles(() => ({
  helpCenterButton: {
    position: "fixed",
    border: 0,
    bottom: "0.75rem",
    right: (props) =>
      props?.loadedWidgetWith
        ? `${props?.loadedWidgetWith + 2}rem !important`
        : "1.725rem",
    zIndex: "2147483647",
    outline: "none",
    background: "transparent",
    display: "block !important",
    transition: "height",
  },
}));

const HELP_SERVICE_DESK_URL =
  "https://mydigitalcar.atlassian.net/servicedesk/customer/portals";

const MDCHelpCenterButton = (props) => {
  const { helpCenterButton } = useStyles(props);

  const openHelpCenter = (event) => {
    event.currentTarget.blur();
    window.open(HELP_SERVICE_DESK_URL, "_blank");
  };

  return (
    <div className={helpCenterButton} id="help-center-button">
      <MDCButton
        variant="helpDesk"
        label="Help Center"
        onClick={openHelpCenter}
        endIcon={<img src={supportHeadsetIcon} alt="Help Icon" />}
      />
    </div>
  );
};

export default MDCHelpCenterButton;
